import { Link } from "react-router";
import { MarcaGeovendas } from "./MarcaGeovendas";
import { ControleDeTema } from "./ControleDeTema";

/** Barra fixa da landing: marca, tema e a única ação que a página pede. */
export function BarraPublica() {
  return (
    <header className="barra-publica">
      <div className="barra-publica__interna">
        <Link to="/" className="barra-publica__marca" aria-label="Início do portal">
          <MarcaGeovendas />
        </Link>
        <div className="barra-publica__acoes">
          {/* O controle de tema some no celular: ali a barra precisa do espaço para a
              ação de entrar, e a preferência do sistema já é respeitada sem ele. */}
          <span className="barra-publica__tema">
            <ControleDeTema />
          </span>
          <Link to="/entrar" className="botao botao--pequeno" data-testid="entrar-barra">
            Entrar
          </Link>
        </div>
      </div>
    </header>
  );
}
